import { Component, Input, Output, EventEmitter, TemplateRef, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../modal/modal.component';

export interface TabConfig {
  key: string;
  label: string;
  contentTemplate: TemplateRef<any>;
}

@Component({
  selector: 'app-tab-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './tab-modal.component.html',
  styleUrl: './tab-modal.component.scss',
})
export class TabModalComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() header: string = '';
  @Input() width: string = '600px';
  @Input() tabs: TabConfig[] = [];
  @Input() defaultTab?: string; // Optional: set default active tab
  @Input() height?: string; // Optional: fixed height for content area

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<void>();

  activeTab: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    // Set default active tab when tabs are set or modal becomes visible
    if (this.tabs.length > 0) {
      if (!this.activeTab || changes['tabs']) {
        this.activeTab = this.defaultTab || this.tabs[0].key;
      }
    }
    
    // Reset to default tab when modal opens
    if (changes['visible'] && changes['visible'].currentValue === true && this.tabs.length > 0) {
      this.activeTab = this.defaultTab || this.tabs[0].key;
    }
  }

  setActiveTab(tabKey: string): void {
    this.activeTab = tabKey;
  }

  handleVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
    
    if (!visible) {
      this.activeTab = this.defaultTab || (this.tabs.length > 0 ? this.tabs[0].key : '');
      this.onClose.emit();
    }
  }
}
